import { ApexOptions } from "apexcharts";
import { Primary, Secondary } from "../../../Constants/Constants";
import { P } from "../../../AbstractElements";

export const RevenueGrowth: ApexOptions = {
  series: [
    {
      name: "Online Sale",
      data: [120, 150, 250, 145, 130, 250, 200, 200, 300, 175, 155, 200],
    },
    {
      name: "Marketing Sale",
      data: [80, 105, 35, 65, 110, 45, 90, 145, 45, 65, 90, 90],
    },
  ],
  colors: [Primary, Secondary],
  chart: {
    type: "area",
    height: 314,
    toolbar: {
      tools: {
        zoom: false,
        zoomin: false,
        zoomout: false,
        reset: false,
        pan: false,
        download: false,
      },
    },
  },
  fill: {
    gradient: {
      opacityFrom: 0.4,
      opacityTo: 0.1,
    },
  },
  markers: {
    discrete: [
      {
        seriesIndex: 0,
        dataPointIndex: 1,
        fillColor: "#fff",
        strokeColor: Primary,
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 2,
        fillColor: "#fff",
        strokeColor: Primary,
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 3,
        fillColor: "#fff",
        strokeColor: Primary,
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 4,
        fillColor: "#fff",
        strokeColor: Primary,
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 5,
        fillColor: "#fff",
        strokeColor: Primary,
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 6,
        fillColor: "#fff",
        strokeColor: Primary,
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 7,
        fillColor: "#fff",
        strokeColor: Primary,
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 8,
        fillColor: "#fff",
        strokeColor: Primary,
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 9,
        fillColor: "#fff",
        strokeColor: Primary,
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 10,
        fillColor: "#fff",
        strokeColor: Primary,
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 1,
        dataPointIndex: 1,
        fillColor: "#fff",
        strokeColor: Secondary,
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 1,
        dataPointIndex: 2,
        fillColor: "#fff",
        strokeColor: Secondary,
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 1,
        dataPointIndex: 3,
        fillColor: "#fff",
        strokeColor: Secondary,
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 1,
        dataPointIndex: 4,
        fillColor: "#fff",
        strokeColor: Secondary,
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 1,
        dataPointIndex: 5,
        fillColor: "#fff",
        strokeColor: Secondary,
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 1,
        dataPointIndex: 6,
        fillColor: "#fff",
        strokeColor: Secondary,
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 1,
        dataPointIndex: 7,
        fillColor: "#fff",
        strokeColor: Secondary,
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 1,
        dataPointIndex: 8,
        fillColor: "#fff",
        strokeColor: Secondary,
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 1,
        dataPointIndex: 9,
        fillColor: "#fff",
        strokeColor: Secondary,
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 1,
        dataPointIndex: 10,
        fillColor: "#fff",
        strokeColor: Secondary,
        size: 3,
        shape: "circle",
      },
    ],
  },
  legend: {
    show: false,
  },
  stroke: {
    curve: "stepline",
    width: 2,
  },
  dataLabels: {
    enabled: false,
  },
  grid: {
    show: true,
    strokeDashArray: 3,
    borderColor: "var(--chart-border)",
    xaxis: {
      lines: {
        show: true,
      },
    },
    yaxis: {
      lines: {
        show: true,
      },
    },
  },
  xaxis: {
    categories: ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"],
    labels: {
      style: {
        colors: ["var(--body-font-color)", "var(--body-font-color)", "var(--body-font-color)", "var(--body-font-color)", "var(--body-font-color)", "var(--body-font-color)", "var(--body-font-color)", "var(--body-font-color)", "var(--body-font-color)", "var(--body-font-color)", "var(--body-font-color)", "var(--body-font-color)"],
      },
    },
    axisTicks: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
  },
  yaxis: {
    labels: {
      style: {
        colors: ["var(--body-font-color)"],
      },
      formatter: (value) => {
        return `${value}$`;
      },
    },
  },
  tooltip: {
    custom: ({ series, seriesIndex, dataPointIndex }) => `
      <div class="apex-tooltip p-2">
        <span>
          <span class="bg-primary"></span>
          Marketing Sale
          <h3>$${series[seriesIndex][dataPointIndex]}</h3>
        </span>
      </div>
    `,
  },
  responsive: [
    {
      breakpoint: 420,
      options: {
        series: [
          {
            name: "Online Sale",
            data: [100, 155, 175, 160, 200, 200, 250],
          },
          {
            name: "Marketing Sale",
            data: [45, 75, 85, 45, 145, 90, 45],
          },
        ],
      },
    },
  ],
};

export const TotalSale: ApexOptions = {
  series: [
    {
      name: "Earning",
      data: [50, 40, 20, 30, 35, 60, 30, 35, 65, 25, 40, 35],
    },
    {
      name: "Earning",
      data: [25, 20, 30, 10, 15, 10, 15, 13, 12, 10, 25, 40],
    },
  ],
  chart: {
    type: "bar",
    height: 302,
    stacked: true,
    toolbar: {
      show: false,
    },
  },
  states: {
    hover: {
      filter: {
        type: "darken",
      },
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: '20%',
    },
  },
  dataLabels: {
    enabled: false,
  },
  grid: {
    yaxis: {
      lines: {
        show: false,
      },
    },
  },
  xaxis: {
    categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    offsetX: 0,
    offsetY: 0,
    axisBorder: {
      offsetX: 0,
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },  
  yaxis: {
    show: false,
  },
  fill: {
    opacity: 1,
    colors: ["#E9F2FF", "#2A5699"],
  },
  legend: {
    show: false,
  },
  responsive: [
    {
      breakpoint: 1199.98,
      options: {
        chart: {
          height: 320
        },
      }
    },
    {
    breakpoint: 420,
    options: { 
      series: [{
        data: [50, 40, 20, 30, 35, 60, 30, 35, 65]
        }, 
        {
          data: [25, 20, 30, 10, 15, 10, 15, 13, 12],
        },
      ],
      xaxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
      }
    }
  }
],
};

export const OptionsLearning: ApexOptions = {
  series: [
    {
      name: "growth",
      type: "line",
      data: [25, 30, 43, 25, 38, 25, 33, 25],
    },
    {
      name: "growth",
      type: "line",
      data: [25, 30, 41, 25, 36, 25, 31, 25],
    },
    {
      name: "growth",
      type: "line",
      data: [25, 29, 37, 25, 34, 25, 29, 25],
    },
    {
      name: "growth",
      type: "line",
      data: [25, 28, 34, 25, 32, 25, 28, 25],
    },
    {
      name: "growth",
      type: "line",
      data: [25, 27, 30, 25, 28, 25, 27, 25],
    },
    {
      name: "growth",
      type: "line",
      data: [25, 26, 24, 25, 24, 25, 24, 25],
    },
    {
      name: "growth",
      type: "line",
      data: [25, 26, 20, 25, 21, 25, 23, 25],
    },
    {
      name: "growth",
      type: "line",
      data: [25, 24, 16, 25, 18, 25, 22, 25],
    },
    {
      name: "growth",
      type: "line",
      data: [25, 23, 12, 25, 15, 25, 21, 25],
    },
    {
      name: "growth",
      type: "line",
      data: [25, 23, 10, 25, 13, 25, 19, 25],
    },
    {
      name: "growth",
      type: "area",
      data: [25, 28, 37, 25, 33, 25, 27, 25],
    },
  ],
  chart: {
    height: 320,
    type: "line",
    toolbar: {
      show: false,
    },
  },
  grid: {
    show: true,
    borderColor: "var(--chart-border)",
    xaxis: {
      lines: {
        show: true,
      },
    },
  },
  colors: [Primary, Secondary, Primary, Secondary, Primary, Secondary, Primary, Secondary, Primary, Secondary, Primary],
  stroke: {
    width: 1.5,
    curve: "smooth",
  },
  markers: {
    discrete: [
      {
        seriesIndex: 0,
        dataPointIndex: 0,
        fillColor: Primary,
        strokeColor: "#fff",
        size: 6,
      },
      {
        seriesIndex: 1,
        dataPointIndex: 5,
        fillColor: Primary,
        strokeColor: "#fff",
        size: 6,
      },
      {
        seriesIndex: 2,
        dataPointIndex: 3,
        fillColor: Primary,
        strokeColor: "#fff",
        size: 6,
      },
    ],
  },
  tooltip: {
    shared: false,
    intersect: false,
  },
  xaxis: {
    type: "category",
    categories: ["Sep 5", "Sep 8", "Sep 12", "Sep 16", "Sep 18", "Sep 17", "Sep 23", "Sep 26"],
    tickAmount: 12,
    labels: {
      style: {
        colors: "var(--chart-text-color)",
        fontSize: "12px",
        fontFamily: "Rubik, sans-serif",
        fontWeight: 400,
      },
    },
    axisTicks: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    tooltip: {
      enabled: false,
    },
  },
  fill: {
    type: ["solid", "solid", "solid", "solid", "solid", "solid", "solid", "solid", "solid", "solid", "gradient"],
    gradient: {
      shade: "light",
      type: "vertical",
      shadeIntensity: 0.5,
      opacityFrom: 0.5,
      opacityTo: 0,
      stops: [0, 80, 100],
    },
  },
  yaxis: {
    min: 0,
    max: 50,
    tickAmount: 5,
    labels: {
      style: {
        colors: "var(--chart-text-color)",
        fontSize: "12px",
        fontFamily: "Rubik, sans-serif",
        fontWeight: 400,
      },
    },
  },
  legend: {
    show: false,
  },
};

export const HigherRevenueData = [
  { title: "Total Revenue", endValue: 756841 },
  { title: "Total Sold", endValue: 435165 },
  { title: "Total Refunds", endValue: 618974 },
  { title: "Total Orders", endValue: 351743 },
];

export const RecentActivityData = [
  { icon: "box", color: "primary", title: "Made new repository", text: "Create different branches", time: "1 hours" },
  { icon: "dolar", color: "secondary", title: "System Updates", text: "Changes in system settings", time: "5 hours" },
  { icon: "round-right", color: "primary", title: "Customer Review", text: "Reviewed all comments", time: "12 Jun" },
  { icon: "pie-chart", color: "secondary", title: "Error Reporting", text: "Highlight recent errors", time: "10 May" },
  { icon: "globe", color: "primary", title: "Enhanced Security", text: "Provides timely alert", time: "18 Feb" },
];

export const TasksListData = [
  {
    color: "primary",
    title: "Review User Feedback",
    text: (
      <P>
        Sending feedback <span className="font-primary">#685 </span> for revision to Smith
      </P>
    ),
  },
  {
    color: "secondary",
    title: "Manage User Permissions",
    text: (
      <P>
        Sending project <span className="font-secondary">#748 </span> for revision to Roberts
      </P>
    ),
  },
  {
    color: "primary",
    title: "Generate Sales Reports",
    text: (
      <P>
        Sending reports <span className="font-primary">#447 </span> for revision to Walker
      </P>
    ),
  },
  {
    color: "secondary",
    title: "Update Product Listings",
    text: (
      <P>
        Sending listings <span className="font-primary">#761 </span> for revision to Jackson
      </P>
    ),
  },
  {
    color: "primary",
    title: "Monitor System Performance",
    text: (
      <P>
        Sending project <span className="font-primary">#654 </span> for revision to Lewis
      </P>
    ),
  },
];

export const NotificationsData = [
  { cardClass: "bg-light", image: "dashboard/user/8.png", title: "Elsa edited Contact page", time: "20 mins ago . Web design" },
  { word: "WD", color: "secondary", title: "Wade left a comment on ACME 2.5", time: "2 hours ago . ACME" },
  { image: "dashboard/user/9.png", title: "Jade shared the file isometric 2.0", time: "4 hours ago . Web Design", button: true },
  { cardClass: "bg-light", word: "FT", color: "primary", title: "Fred Tels edited ACME 2.4", time: "6 hours ago . ACME" },
  { image: "dashboard/user/10.png", title: "Helena created user-card page", time: "9 hours ago . Blank" },
];

export const OrderData = [
  {
    name: "Brian Adams",
    image: "dashboard/user/1.png",
    code: "#Ft6854K",
    day: "10 May, 2024",
    time: "10:15 PM",
    product: "House Plants",
    amount: "$354",
    status: "Paid",
    status_class: "bg-light-primary txt-primary",
  },
  {
    name: "Amelia Jones",
    image: "dashboard/user/2.png",
    code: "#B9547KB",

    day: "10 Jan, 2024",
    time: "05:20 PM",
    product: "Fancy Mug",
    amount: "$345",
    status: "Pending",
    status_class: "bg-light-secondary txt-secondary",
  },
  {
    name: "Luna Garcia",
    image: "dashboard/user/3.png",
    code: "#J3478D",
    day: "21 Aug, 2024",
    time: "06:12 PM",
    product: "Modern Calender",
    amount: "$475",
    status: "Paid",
    status_class: "bg-light-primary txt-primary",
  },
  {
    name: "Darby Jones",
    image: "dashboard/user/4.png",
    code: "#GTR345",
    day: "25 Nov, 2024",
    time: "11:30 PM",
    product: "Smart Phone",
    amount: "$324",
    status: "Overdue",
    status_class: "bg-light-warning txt-warning",
  },
];

export const TrendingNewsData = [
  {image:"dashboard/news/news-1.jpg",title:"Highlight events effortlessly with Trending card display...",time:"4 months ago"},
  {image:"dashboard/news/news-2.jpg",title:"Keep audience informed with intuitive News cards....",time:"5 months ago"},
  {image:"dashboard/news/news-3.jpg",title:"Engage users with updates using latest card feature....",time:"7 months ago"},
  {image:"dashboard/news/news-4.jpg",title:"Stay updated with the latest trends through dynamic....",time:"8 months ago"},
];

export const ProgressBarData =["primary", "secondary","success","warning"];

export const ChartData =[
  {title:"Keyboard",color:"bg-primary",value:"651"},
  {title:"Laptops",color:"bg-secondary",value:"345"},
  {title:"Desktop",color:"bg-success",value:"654"},
  {title:"Mouse",color:"bg-warning",value:"954"},
]

export const AllOverProductSaleData =[
  {color:"fill-primary",title:"United States",percentage:"53.23%"},
  {color:"fill-secondary",title:"Romania",percentage:"31.85%"},
  {color:"fill-success",title:"Austalia",percentage:"12.98%"},
  {color:"fill-warning",title:"Germany",percentage:"45.23%"},
  {color:"fill-primary",title:"Africa",percentage:"23.15%"},
  {color:"fill-secondary",title:"Europe",percentage:"95.75%"},
]

export const CustomerReviewData = [
  {image:"dashboard/slider/1.png",title:"Mary Jades",text:"Web Designer",content:"This product exceeded my expectations! The quality is outstanding, and it arrived faster than I anticipated. Also, thank you for the support. Highly recommend!",date:"( 10th Feb, 2024 )"},
  {image:"dashboard/slider/2.png",title:"Anna Proas",text:"Graphics Designer",content:"I love how versatile this product is. It's perfect for everyday use and has made a noticeable difference in my routine. Definitely worth the purchase.",date:"( 05th May, 2024 )"},
  {image:"dashboard/slider/3.png",title:"Rachel Green",text:"Web Developer",content:"Great value for the price! It's durable, stylish, and exactly what I was looking for. Couldn't be happier with my choice. Also, thank you for the quick response.",date:"( 23th Aug, 2024 )"},
]

export const CustomerReviewOptions = {
  dots: true,
  infinite: true,
  speed: 500,
  AutoPlay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  draggable: true,
  pauseOnHover: true,
  arrows:false,
};
